import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CountryDropdownField, DunsNumberAbbr, ReasonOfRequestDropdownField, TaxIdField, TextField, YesNoField } from '../../../components';
import { FormSection, FieldArray } from '../../../libs/reduxForm';
import { Validation } from '../../../services';

var AddressComponent = function AddressComponent(_ref) {
  var fields = _ref.fields,
      onAddressOptionChange = _ref.onAddressOptionChange;
  return fields.map(function (fieldName, index) {
    return React.createElement(FormSection, {
      key: fieldName,
      name: fieldName
    }, index === 0 && React.createElement('h2', null, 'Main Address'), index === 1 && React.createElement('h2', null, 'Billing address'), React.createElement(TextField, {
      label: 'Street*',
      name: 'address_line',
      placeholder: 'Enter Street',
      validate: [Validation.required]
    }), React.createElement(TextField, {
      label: 'Number*',
      name: 'address_number',
      placeholder: 'Enter Number',
      validate: [Validation.required]
    }), React.createElement(TextField, {
      label: 'Locality',
      name: 'neighborhood',
      placeholder: 'Enter Locality'
    }), React.createElement(TextField, {
      label: 'City*',
      name: 'city',
      placeholder: 'Enter City',
      validate: [Validation.required]
    }), React.createElement(TextField, {
      label: 'State/Department/Province/Region*',
      name: 'state',
      placeholder: 'Enter State/Department/Province/Region',
      validate: [Validation.required]
    }), React.createElement(TextField, {
      label: 'Postal Code*',
      name: 'postal_code',
      placeholder: 'Enter Postal Code',
      validate: [Validation.required]
    }), index === 0 && React.createElement(YesNoField, {
      onChange: function onChange(event) {
        return onAddressOptionChange(fields, event.target.value);
      },
      label: 'Is the address above also your Billing/Mailing address? If not, please select no and fill out the section below.',
      name: 'hasSingleAddress'
    }));
  });
};

var CompanyStep =
/*#__PURE__*/
function (_Component) {
  _inherits(CompanyStep, _Component);

  function CompanyStep() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CompanyStep);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CompanyStep)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.showReasonOfRestriction = function () {
      return React.createElement('div', {
        className: 'GetDunsNumberForm-redirect'
      }, React.createElement('p', null, 'CIAL Dun & Bradstreet provides ', React.createElement(DunsNumberAbbr, null), ' for organizations across Latin America and the Caribbean, excluding Colombia. You have selected a country outside of this region.', React.createElement('br', null), React.createElement('br', null), 'Please visit this page to find your D&B local partner and proceed with your ', React.createElement(DunsNumberAbbr, null), ' request:', React.createElement('br', null), React.createElement('br', null), React.createElement('a', {
        href: 'https://www.dnb.com/choose-your-country.html'
      }, 'https://www.dnb.com/choose-your-country.html'), '.'));
    }, _this.handleAddressOptionChange = function (fields, value) {
      if (value === 'no' && fields.length === 1) {
        fields.push({
          is_main_address: false
        });
      } else if (fields.length > 1) {
        fields.pop();
      }
    }, _this.shouldRestrictDunsForm = function () {
      return !_this.props.selectedCialCountry;
    }, _this.state = {
      error: undefined,
      errorInfo: undefined
    }, _temp));
  }

  _createClass(CompanyStep, [{
    key: "preSection",
    value: function preSection() {
      var _this$props = this.props,
          selectedCountryRegionName = _this$props.selectedCountryRegionName,
          user = _this$props.user;
      return React.createElement(Fragment, null, React.createElement(CountryDropdownField, {
        label: 'Your Company\'s Country*',
        name: 'country',
        placeholder: 'Select one of the following',
        validate: [Validation.required],
        user: user
      }), React.createElement(ReasonOfRequestDropdownField, {
        label: React.createElement('span', null, 'Is a business partner requiring you to get a ', React.createElement(DunsNumberAbbr, null), '? If so, please select an option from the list below.'),
        name: 'reason_of_request',
        placeholder: 'Select one of the following',
        regionName: selectedCountryRegionName
      }), this.shouldRedirectUser() && this.redirectInfo(), this.shouldRestrictDunsForm() && this.showReasonOfRestriction());
    }
  }, {
    key: "redirectInfo",
    value: function redirectInfo() {
      var selectedReasonOfRequest = this.props.selectedReasonOfRequest;
      return React.createElement('div', {
        className: 'GetDunsNumberForm-redirect'
      }, React.createElement('p', null, 'Some CIAL Dun & Bradstreet business partners require you to fulfill your ', React.createElement(DunsNumberAbbr, null), ' request on a separate website. Please follow the instructions on this page in order to receive your ', React.createElement(DunsNumberAbbr, null), ':'), selectedReasonOfRequest && React.createElement('p', null, React.createElement('strong', null, React.createElement('a', {
        href: selectedReasonOfRequest.redirect.url
      }, selectedReasonOfRequest.redirect.url))), React.createElement('br', null), selectedReasonOfRequest && React.createElement('p', null, 'Support email:', React.createElement('strong', null, selectedReasonOfRequest.redirect.emails && selectedReasonOfRequest.redirect.emails.map(function (email) {
        return React.createElement('a', {
          key: email,
          className: 'support-email',
          href: "mailto:".concat(email)
        }, email);
      }))), React.createElement('br', null), React.createElement('p', null, 'Thank you for your understanding.'));
    }
  }, {
    key: "companyDetails",
    value: function companyDetails() {
      if (this.shouldRedirectUser() || this.shouldRestrictDunsForm()) {
        return;
      }

      var metadata = this.props.metadata;
      var taxIdValidation = metadata.isDunsForBrazil ? [Validation.customTaxIdBrazilValidation] : [];
      return React.createElement(FormSection, {
        name: 'company'
      }, React.createElement(TextField, {
        label: 'Your Job Title*',
        name: 'position',
        placeholder: 'Enter Your Job Title',
        validate: [Validation.required]
      }), React.createElement('h2', null, 'Company details'), React.createElement(TextField, {
        label: 'Company Legal Name*',
        name: 'name',
        placeholder: 'Enter Company Legal Name',
        validate: [Validation.required]
      }), React.createElement(TextField, {
        label: 'Trade Name(s)',
        name: 'trade_name',
        placeholder: 'Enter Trade Name(s)'
      }), React.createElement(TaxIdField, {
        label: 'Tax ID*',
        name: 'tax_number',
        validate: [Validation.required].concat(taxIdValidation)
      }), React.createElement(TextField, {
        label: 'Website',
        name: 'website',
        placeholder: 'Enter Website'
      }), React.createElement(TextField, {
        label: 'E-mail*',
        name: 'email',
        placeholder: 'Enter E-mail',
        validate: [Validation.required]
      }), React.createElement(TextField, {
        label: 'Primary Phone Number*',
        name: 'phone',
        placeholder: 'Enter Primary Phone Number',
        validate: [Validation.required]
      }), React.createElement(TextField, {
        label: 'Secondary Phone Number',
        name: 'fax',
        placeholder: 'Enter Secondary Phone Number'
      }));
    }
  }, {
    key: "companyAddresses",
    value: function companyAddresses() {
      if (this.shouldRedirectUser() || this.shouldRestrictDunsForm()) {
        return;
      }

      return React.createElement(FieldArray, {
        name: 'company.addresses',
        component: AddressComponent,
        onAddressOptionChange: this.handleAddressOptionChange
      });
    }
  }, {
    key: "shouldRedirectUser",
    value: function shouldRedirectUser() {
      var selectedReasonOfRequest = this.props.selectedReasonOfRequest;
      return !!(selectedReasonOfRequest && selectedReasonOfRequest.redirect);
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
      console.log(error);
      console.log(errorInfo); // You can also log error messages to an error reporting service here
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.errorInfo) {
        // Error path
        return React.createElement('div', null, React.createElement('h2', null, 'Something went wrong.'), React.createElement('details', {
          style: {
            whiteSpace: 'pre-wrap'
          }
        }, this.state.error && this.state.error.toString(), React.createElement('br', null), this.state.errorInfo.componentStack));
      }

      return React.createElement(Fragment, null, this.preSection(), this.companyDetails(), this.companyAddresses());
    }
  }]);

  return CompanyStep;
}(Component);

CompanyStep.propTypes = {
  selectedCountryRegionName: PropTypes.string.isRequired,
  selectedReasonOfRequest: PropTypes.object,
  selectedCialCountry: PropTypes.bool.isRequired,
  metadata: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};
export default CompanyStep;